<template>
  <div class="signature-pad-wrap">
    <canvas ref="canvas" class="sig-canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
    <div class="text-center g">
      <small class="text-muted">وقّع باستخدام الإصبع أو الماوس في المربع أعلاه</small>
      <br>
      <button class="btn btn-warning btn-sm g" @click="clear" type="button">
        <i class="fa fa-eraser"></i> مسح والبدء من جديد
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',
  data(){
    return {
      drawing: false,
      lastX: 0,
      lastY: 0,
      isEmpty: true,
      canvasWidth: 500,
      canvasHeight: 200
    }
  },
  mounted(){
    var c = this.$refs.canvas;
    var ctx = c.getContext('2d');
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#1e293b';
    var self = this;

    var getPos = function(e){
      var rect = c.getBoundingClientRect();
      var clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      var clientY = (e.touches && e.touches[0]) ? e.touches[0].clientY : e.clientY;
      return {
        x: (clientX - rect.left) * (c.width / rect.width),
        y: (clientY - rect.top) * (c.height / rect.height)
      };
    };

    var start = function(e){
      e.preventDefault();
      self.drawing = true;
      var p = getPos(e);
      self.lastX = p.x;
      self.lastY = p.y;
      ctx.beginPath();
      ctx.moveTo(p.x, p.y);
      ctx.lineTo(p.x+0.01, p.y+0.01);
      ctx.stroke();
      self.isEmpty = false;
    };
    var move = function(e){
      if(!self.drawing){ return; }
      e.preventDefault();
      var p = getPos(e);
      ctx.beginPath();
      ctx.moveTo(self.lastX, self.lastY);
      ctx.lineTo(p.x, p.y);
      ctx.stroke();
      self.lastX = p.x;
      self.lastY = p.y;
    };
    var end = function(e){
      if(e){ e.preventDefault && e.preventDefault(); }
      self.drawing = false;
    };

    c.addEventListener('mousedown', start);
    c.addEventListener('mousemove', move);
    c.addEventListener('mouseup', end);
    c.addEventListener('mouseleave', end);
    c.addEventListener('touchstart', start, {passive: false});
    c.addEventListener('touchmove', move, {passive: false});
    c.addEventListener('touchend', end, {passive: false});
    c.addEventListener('touchcancel', end, {passive: false});
  },
  methods: {
    clear(){
      var c = this.$refs.canvas;
      var ctx = c.getContext('2d');
      ctx.clearRect(0, 0, c.width, c.height);
      this.isEmpty = true;
    },
    getData(){
      if(this.isEmpty){ return null; }
      return this.$refs.canvas.toDataURL('image/png');
    }
  }
}
</script>

<style scoped>
.signature-pad-wrap{
  text-align: center;
}
.sig-canvas{
  border: 2px dashed #0BA6DF;
  border-radius: 8px;
  background: #f8fafc;
  width: 100%;
  max-width: 500px;
  height: 200px;
  touch-action: none;
  cursor: crosshair;
  display: block;
  margin: 0 auto;
}
</style>
